import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth, signInAnonymously } from "firebase/auth";

export default function FirebaseApp() {
  return new Promise((resolve, reject) => {
    const firebaseConfig = {
      apiKey: "AIzaSyBQoowuGCYxCYr7wj_-6cIJzHaZVxsNvBA",
      authDomain: "mind-reset-33396.firebaseapp.com",
      databaseURL: "https://mind-reset-33396.firebaseio.com",
      projectId: "mind-reset-33396",
      storageBucket: "mind-reset-33396.appspot.com",
      messagingSenderId: "1065218710379",
      appId: "1:1065218710379:web:a3c29f121a55aa35838a2e"
    };

    const app = initializeApp(firebaseConfig);
    const auth = getAuth(app);
    signInAnonymously(auth)
      .then(() => {
        console.log("signed in");
        resolve(getDatabase(app));
      })
      .catch((error) => {
        console.log(error.code);
        console.log(error.message);
        reject(error);
      });
  });
}
